import React from 'react';
import PropTypes from 'prop-types';
import { FooterWrapper, FooterContent } from '../../style';
import { checkCSRBusinessFunction } from '../../../../../../CSR/utils/CommonUtils';
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import { CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';

const EditableRecurringFooter = (props) => {
  return (
    <FooterWrapper EditableFooter>
      <FooterContent>
        <div>Total</div>
        <p>{props.totalAmount}</p>
      </FooterContent>
      {checkCSRBusinessFunction(
        BUSINESS_FUNCTION[
          'DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS'
        ],
        props.csrBusinessFunction
      ) ? (
        <CapsuleButton
          id="btnAddGrant1"
          text="Add Grant"
          iconType="add"
          disabled={true}
          alt = "add icon"
        />
      ) : (
        <CapsuleButton
          id="btnAddGrant2"
          text="Add Grant"
          onClick={props.addGrandHandler}
          iconType="add"
          alt = "add icon"
          
        />
      )}
    </FooterWrapper>
  );
};

EditableRecurringFooter.propTypes = {
  addGrandHandler: PropTypes.func,
  csrBusinessFunction: PropTypes.any,
  totalAmount: PropTypes.string,
};

export default EditableRecurringFooter;
